export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || "admin@vyrapharma.in";
export const TOKEN_EXPIRY_BUFFER = parseInt(process.env.REACT_APP_TOKEN_EXPIRY_BUFFER || "300", 10);

export const ROUTES = {
  LOGIN: "/login",
  ADMIN_DASHBOARD: "/admin/dashboard",
  ADMIN_EMPLOYEES: "/admin/employees",
  ADMIN_CREATE_EMPLOYEE: "/admin/create-employee",
  ADMIN_EDIT_EMPLOYEE: "/admin/edit-employee/:id",
  ADMIN_DCR_REPORTS: "/admin/dcr-reports",
  EMPLOYEE_DASHBOARD: "/employee/dashboard",
  EMPLOYEE_DCR: "/employee/dcr",
  EMPLOYEE_DCR_REPORT: "/employee/dcr-report",
};

export const USER_ROLES = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
};

export const EMPLOYEE_STATUS = {
  ACTIVE: "active",
  DISABLED: "disabled",
};

export const STORAGE_KEYS = {
  AUTH: "vyra_auth",
  TOKEN: "vyra_token",
  REFRESH_TOKEN: "vyra_refresh_token",
  USER: "vyra_user",
};
